// General Images
import imageGlobeLogo from '../assets/globe_logo.png';
import imageWolfInvestmentLogo from '../assets/wolf_logo.png'
import imageWolfInvestmentQrCode from '../assets/wolf_qr.png';

// Section related Images

// Home section
import imageHomeBanner from '../assets/banner_img.png';
import imageHomeBackground from '../assets/home_bg.svg'; // Not in Use

// What you get section
import illustrationWhatYouGet from '../assets/illustrations/WYG.png';

// Stock Market Mantra section
import illustrationStockMarketMantra from '../assets/illustrations/SMM.png';

// We've Got you covered Section
import illustrationBeginnerTrader from '../assets/illustrations/BEGI.png';
import illustrationItermidiateTrader from '../assets/illustrations/ITDI.png';
import illustrationExpertTrader from '../assets/illustrations/EXPI.png';

// About Me section
import imageAboutMe from '../assets/about_me_img.png';

// What Clients say section
import illustrationTestimonials from '../assets/illustrations/WCS.png';

// Download App banner
import imageDownloadAppBanner from '../assets/app-banner.png';

//404 Page Not Found
import illustration404 from '../assets/illustrations/404.png'



const AssetImages ={
    imageGlobeLogo :{
        src: imageGlobeLogo,
        alt: 'Globe Logo'
    },
    imageWolfInvestmentLogo : {
        src: imageWolfInvestmentLogo,
        alt: 'Wolf Investment Logo'
    },
    imageWolfInvestmentQrCode : {
        src: imageWolfInvestmentQrCode,
        alt: 'Open Free Demat Account Qr Code'
    },
    imageHomeBanner :  {
        src: imageHomeBanner,
        alt: ''
    },
    imageHomeBackground :  {
        src: imageHomeBackground,
        alt: ''
    },
    illustrationWhatYouGet: {
        src: illustrationWhatYouGet,
        alt: ''
    },
    illustrationStockMarketMantra: {
        src: illustrationStockMarketMantra,
        alt: ''
    },
    illustrationBeginnerTrader: {
        src: illustrationBeginnerTrader,
        alt: ''
    },
    illustrationItermidiateTrader: {
        src: illustrationItermidiateTrader,
        alt: ''
    },
    illustrationExpertTrader: {
        src: illustrationExpertTrader,
        alt: ''
    },
    imageAboutMe: {
        src: imageAboutMe,
        alt: ''
    },
    illustrationTestimonials: {
        src: illustrationTestimonials,
        alt: ''
    },
    imageDownloadAppBanner: {
        src: imageDownloadAppBanner,
        alt: 'Globe App Banner'
    },
    illustration404: {
        src: illustration404,
        alt: ''
    }
}

export default AssetImages;